function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { omitBy, isNil } from "lodash"; //we use this to make adding preset prop groups simpler

export default function computePresets(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      isSimple = _props.isSimple;
  var toReturn = omitBy(props, isNil);
  toReturn.pageSize = toReturn.controlled_pageSize || toReturn.pageSize;

  if (isSimple) {
    //isSimplePreset
    toReturn = _extends({
      noHeader: true,
      noFooter: !props.withPaging,
      noPadding: true,
      noFullscreenButton: true,
      hidePageSizeWhenPossible: !props.withPaging,
      isInfinite: !props.withPaging,
      hideSelectedCount: true,
      withTitle: false,
      withSearch: false,
      compact: true,
      withPaging: false,
      withFilter: false
    }, toReturn);
  } else {
    toReturn = _extends({
      // the usual defaults:
      noFooter: false,
      noPadding: false,
      compact: true,
      noFullscreenButton: false,
      hidePageSizeWhenPossible: false,
      isInfinite: false,
      hideSelectedCount: false,
      withTitle: true,
      withSearch: true,
      withPaging: true,
      withFilter: true
    }, toReturn);
  }

  return toReturn || {};
}